import { Injectable } from '@angular/core';
import {RxdbRepository} from "../rxdb.repository";
import {Page} from "../../utils/page";
import {CmcProtocol} from "../../models/cmc/cmc-protocol.model";
import {deepCloneListWithPrototype} from "../../utils/clone-utils";

@Injectable({
    providedIn: 'root'
})
export class RxdbCmcProtocolRepository {

    private collectionName : string;
    constructor(private readonly rxdbRepository: RxdbRepository) {
        this.collectionName = 'cmcprotocols'
    }
    async searchPagedCmcProtocols(countryIsoCode: string, userRole: string, pageable: Map<string, string>, searchParam: string): Promise<Page<CmcProtocol>> {
        this.collectionName = countryIsoCode.toLowerCase() + '_' + 'cmcprotocols';

        const page = pageable.has('page') ? parseInt(pageable.get('page')!) : 0;
        const size = pageable.has('size') ? parseInt(pageable.get('size')!) : 20;

        let selector: any = {
            countryIsoCode: countryIsoCode
        };

        if (searchParam) {
            selector.$or = [
                { name: { $regex: searchParam, $options: 'i' } },
                { code: { $eq: searchParam } }
            ]
        }
        let db = await this.rxdbRepository.initDb();
        const pagedDocs = await db[this.collectionName]
            .find({
                selector: selector,
                sort: [{ _id: 'asc' }],
                skip: page * size,
                limit: size
            })
            .exec();

        const totalDocumentsCount = await db[this.collectionName]
            .count({ selector: selector })
            .exec();

        return {
            totalElements: totalDocumentsCount,
            totalPages: Math.ceil(totalDocumentsCount / size),
            first: page === 0,
            last: (page + 1) * size >= totalDocumentsCount,
            size: size,
            content: deepCloneListWithPrototype(pagedDocs.map(d => d._data), CmcProtocol),
            number: page,
            numberOfElements: pagedDocs.length,
            empty: pagedDocs.length === 0
        };
    }

    async hasCmcProtocols(countryIsoCode: string): Promise<boolean> {
        const collectionName = countryIsoCode.toLowerCase() + '_cmcprotocols';
        const db = await this.rxdbRepository.initDb();
        const count = await db[collectionName]
            .count({ selector: { countryIsoCode: countryIsoCode } })
            .exec();
        return count > 0;
    }

}
